export function getConfig (){
    return {
        "backend-url" : "https://api.genomicscore.be"
        
    };
}